import { useEffect, useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { Blockquote, Group, LoadingOverlay, Stack, Text } from "@mantine/core";
import BackButton from "../../../../components/View/BackButton";
import { getWebhooks } from "../../../../api/ConfigsApi";
import CreateWebhook from "./CreateWebhook";
import WebhookItem from "./WebhookItem";
import { IconInfoCircle } from "@tabler/icons-react";

const WebhooksContent = ({ handleClose }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (loading) {
      getWebhooks()
        .then((response) => {
          setItems(response.data.webhooks);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [loading]);

  return (
    <>
      <Stack pos={"relative"} gap={"xs"} h={"100%"} flex={1}>
        <LoadingOverlay visible={loading} />

        <Text c={"dimmed"}>{lang.webhooks.text}</Text>

        <Blockquote
          color="blue"
          icon={<IconInfoCircle />}
          my="lg"
          pl={"xl"}
          py={"md"}
        >
          {lang.webhooks.info} {"{"} event_id, workflow_programmation_id, event,
          workflow_id, workflow_programmation_contact_id, properties,
          date_event, prm_contacts_id {"}"} <br />
          <span style={{ fontWeight: 500 }}>{lang.webhooks.text_200}</span>
        </Blockquote>

        {items.length > 0 ? (
          <Group
            gap={"lg"}
            h={"50vh"}
            style={{ overflow: "auto" }}
            align="start"
          >
            {items.map((item, index) => {
              return (
                <WebhookItem
                  key={item.id}
                  item={item}
                  handleReload={() => setLoading(true)}
                />
              );
            })}
          </Group>
        ) : (
          <Stack>
            <Text c={"dimmed"} size="lg" ta={"center"} mt={64}>
              {lang.webhooks.no_item}
            </Text>
            <CreateWebhook
              handleDone={() => setLoading(true)}
              variant="light"
              w={300}
              mx="auto"
            />
          </Stack>
        )}
      </Stack>

      <Group justify="end" mt={"lg"}>
        <BackButton onClick={handleClose} size="md" />
        <CreateWebhook handleDone={() => setLoading(true)} />
      </Group>
    </>
  );
};

export default WebhooksContent;
